<template>
  <div class="body">
    <div class="main_container">
      <!-- <training-header></training-header> -->

      <!-- page content -->
      <div class="right_col" role="main" style="margin-left: 0; background-color: #fff;">
        <div class="row">
          <div class="col-lg-10 mx-auto pt-4">
            <div class="row mb-3">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="flex-container certification_status">
              <div class="middle-div">
                <div>
                  <img
                    src="../assets/img/unfillcertificate.jpg"
                    alt
                    style="width: 200px; display: block; margin:0 auto;"
                  />
                </div>
                <br />
                <h2>Check Your Certification Status</h2>
                <p style="font-size:14px;">
                  The kinds of birth control that work the best to prevent pregnancy are the implant and IUDs — they're also the most convenient to use, and the most foolproof. Other birth control methods, like the pill, ring, patch, and shot, are also really good at preventing pregnancy if you use them perfectly.
                </p>
                <!-- <form>
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id
                      value="AD45678XR5678906"
                      style="width: 400px; margin: 0 auto 4%;"
                    />
                  </div>

                  <a href="scoreboard_verify.html" class="btn btn-info">Check Status</a>
                </form>
                <br />
                <a href="forgot_id_details.html" class="forgot_id_wrap">Forgot 16 character exam id?</a> -->

              </div>
            </div>
          </div>
        </div>
                <div class="row px-4 mb-5">
                  <div class="col-12">
                    <div class="tableFixHead">
                      <table class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Sr. No.</th>
                            <th scope="col">Examination Id</th>
                            <th scope="col">Date Of Exam</th>
                            <th scope="col">Score</th>
                            <th scope="col">Status</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody v-if="examList && examList.length">
                          <template v-for="(list, i) in examList">
                            <tr :key="i">
                              <td scope="row">{{i+1}}</td>
                              <td>{{list.examId}}</td>
                              <td>{{list.createdOn.split(' ')[0]}}</td>
                              <td>{{list.score}}</td>
                              <td v-if="list.result == 'passed'">Pass</td>
                              <td v-else>Fail</td>
                              <td>
                                <button @click="getCertificate(list)" v-if="list.result == 'passed'" type="button" class="btn btn-primary action_btn"> View Certificate</button>
                                <a hre="#/exam-id"><button type="button" class="btn btn-success action_btn"> Retake Exam</button></a>
                              <!-- <button type="button" class="btn btn-danger"><i class="far fa-trash-alt"></i></button> -->
                              </td>
                            </tr>
                          </template>
                        </tbody>
                        <tbody v-else>
                            <tr>
                              <td colspan="6">No Certificate Found</td>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
          </div>
        </div>


      </div>
      <!-- /page content -->

      <!-- footer content -->
      <!-- <training-footer></training-footer> -->
      <!-- /footer content -->
    </div>
  </div>
</template>
<script>
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
import ApiServices from '../service/ApiServices';
export default {
    data(){
      return {
        examList: null
      }
    },
    components: {
        trainingHeader,
        trainingFooter
    },
    methods:{
       getExamList(){
        this.$root.loading = true;
        ApiServices.RestPostCall('api/avenir/training/getUserExamList',{}).then(res=>{
            this.$root.loading = false;
            this.examList = res.examDetails;
        })
      },
      getCertificate(list){
        localStorage.setItem("certificate-data",JSON.stringify(list));
        this.$router.push("/certificate");
      }
    },
    mounted(){
      localStorage.setItem("route-name", this.$route.name);
      this.getExamList()
    }
}
</script>
<style lang="scss" scoped>
.flex-container{
    height: auto !important;
}
// .tableFixHead          { overflow-y: auto; height: 400px; }
// .tableFixHead thead th { position: sticky; top: 0; }

// /* Just common table stuff. Really. */
// table  { border-collapse: collapse; width: 100%; }
// th, td { padding: 8px 16px; }
// th     {  }
.table thead th {

    font-size: 1.3em;
    font-weight: 500;
}
.table td{
  font-size: 14px;
}
.action_btn{
  font-size: 12px;
}
.right_col{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
